import { useState, useEffect } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MeetingStopwatchProps {
  durationMinutes: number;
  onComplete?: () => void;
}

export function MeetingStopwatch({ 
  durationMinutes, 
  onComplete 
}: MeetingStopwatchProps) {
  const [timeLeft, setTimeLeft] = useState(durationMinutes * 60);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;
        if (newTime <= 0) {
          clearInterval(interval);
          onComplete?.();
          return 0;
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onComplete]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center gap-4">
      <div className="text-5xl font-mono font-bold text-blue-500">
        {formatTime(timeLeft)}
      </div>
      <div className="flex gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            setTimeLeft(durationMinutes * 60);
          }}
          className="h-12 w-12 text-blue-500 hover:text-blue-400 hover:bg-blue-500/10"
        >
          <RotateCcw className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
}
